import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Retargeting Placement',
    entityNamePlural: 'Retargeting Placement',
    entityNameModule: 'path',
    filters: { active: true },
    basePath: '/path/retargeting',
    enableTableResize: false,
  }), [])
}
